import React from "react";

interface ShieldIconIntRevProps {
  width?: string;
  height?: string;
  isActive?: boolean;
}

const ShieldIconIntRev: React.FC<ShieldIconIntRevProps> = ({
  width = "17px",
  height = "16px",
  isActive = false,
}) => {
  const fillColor = `var(--${isActive ? "theme-primary-color" : "theme-inactive-color"})`;

  return (
    <svg
      width={width ?? "17"}
      height={height ?? "16"}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.7687 8.75L7.0187 10.25L10.2687 5.75M0.768698 4L8.0187 0.75L15.2687 4C15.2687 4 16.0187 15.25 8.0187 15.25C0.0186982 15.25 0.768698 4 0.768698 4Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShieldIconIntRev;
